export const adjustSignaturesData = () => {
  return [
    {
      name: 'ИП Александровский Борис Анд…',
      position: 'Руководитель',
      signatory: 'Александровский Б.А.',
      signature: null,
      seal: null,
    },
    {
      name: 'Бурмантов Л.И.',
      position: 'Руководитель',
      signatory: 'Константинопольский К.К.',
      signature: null,
      seal: null,
    },
  ];
};
